/**
 * AWS Amplify Configuration
 */

import { Amplify } from 'aws-amplify';

export interface AmplifyConfig {
    Auth: {
        Cognito: {
            userPoolId: string;
            userPoolClientId: string;
            identityPoolId?: string;
            loginWith: {
                email?: boolean;
                username?: boolean;
                phone?: boolean;
            };
            signUpVerificationMethod: 'code' | 'link';
            userAttributes: {
                email: {
                    required: boolean;
                };
                name: {
                    required: boolean;
                };
                phone_number: {
                    required: boolean;
                };
            };
            passwordFormat: {
                minLength: number;
                requireLowercase: boolean;
                requireNumbers: boolean;
                requireSymbols: boolean;
                requireUppercase: boolean;
            };
        };
    };
    oauth?: {
        domain: string;
        scope: string[];
        redirectSignIn: string;
        redirectSignOut: string;
        responseType: 'code' | 'token';
    };
}

// Environment variables for Amplify configuration
const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
            userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID || '',
            ...(process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID && {
                identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
            }),
        },
    },
    ...(process.env.REACT_APP_COGNITO_DOMAIN && {
        oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN,
            scope: [
                'openid',
                'email',
                'profile',
                'aws.cognito.signin.user.admin'
            ],
            redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || 'http://localhost:3000/auth/callback',
            redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || 'http://localhost:3000/login',
            responseType: 'code' as const,
        },
    }),
};

// Validate required configuration
export const validateAmplifyConfig = (): boolean => {
    const required = ['userPoolId', 'userPoolClientId'];
    return required.every(key => amplifyConfig.Auth.Cognito[key as keyof typeof amplifyConfig.Auth.Cognito]);
};

// Configure Amplify
export const configureAmplify = (): void => {
    if (!validateAmplifyConfig()) {
        console.warn('Amplify configuration is incomplete. Please check your environment variables.');
    }

    try {
        Amplify.configure(amplifyConfig as any);
        console.log('Amplify configured successfully');
    } catch (error) {
        console.error('Error configuring Amplify:', error);
    }
};

// Export the configuration for reference
export { amplifyConfig };
